<template>
    <div class="my-3">
        <v-expand-transition>
            <v-row>
                <v-col md="6">
                    <div @click="alterarStatus(29)">
                        <Indicador
                            titulo="Espaco Reservado"
                            :valor="indicadores[29]"
                            icone="$alertCircleCheckOutline"
                            :class="{
                                active: status.includes(29),
                            }"
                        />
                    </div>
                </v-col>

                <v-col md="6">
                    <div @click="alterarStatus(28)">
                        <Indicador
                            titulo="Acordos Cancelados"
                            :valor="indicadores[28]"
                            icone="$documentRemove"
                            :class="{
                                active: status.includes(28),
                            }"
                        />
                    </div>
                </v-col>
            </v-row>
        </v-expand-transition>
    </div>
</template>

<script>
import Indicador from "./_components/Indicador.vue";

export default {
    components: {
        Indicador,
    },
    props: ["indicadores", "filtro"],
    computed: {
        status: function () {
            return this.filtro?.filtro?.id_status || [];
        },
    },
    data() {
        return {
            expand: true,
        };
    },
    methods: {
        alterarStatus: function (status) {
            if (this.status.includes(status)) {
                this.filtro.filtro.id_status = this.status.filter(
                    (s) => s != status
                );
            } else {
                this.filtro.filtro.id_status = [status];
            }
            this.filtro.filtrar();
        },
    },
};
</script>
